module.exports = __webpack_public_path__ + "static/media/OrchidImg.4793e9f1.webp";